import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 批量添加不上传到收费系统的学生
  batchMealAddExclusiveStudent(_postData) {
    return http.post(
      URL.API_STUDENT_MEAL_BATCH_ADD_EXCLUSIVE_STUDENT,
      _postData
    )
  },
  // 导出学生用餐记录为Excel（通过工作通知发送给操作人员）
  exportMealRecordExcel(_postData) {
    return http.post(URL.API_STUDENT_MEAL_EXPORT_RECORD, _postData)
  },
  // 查询该校区下所有班级就餐统计
  getMealAllClassMealStatistics(_postData) {
    return http.get(URL.API_STUDENT_MEAL_GET_ALL_STATISTICS, _postData)
  },
  // 根据日期查询学生就餐状态 -1当天无数据 0当天有数据且没有未吃饭记录 1当天有数据且存在未吃饭记录
  getMealDimDayStatus(_postData) {
    return http.get(URL.API_STUDENT_MEAL_GET_DAY_STATUS, _postData)
  },
  // 分页查询不上传到收费系统的学生
  getMealPageExclusiveStudent(_postData) {
    return http.get(URL.API_STUDENT_MEAL_GET_EXCLUSIVE_STUDENT, _postData)
  },
  // 根据状态查询学生列表
  getMealStudentListByMealStatus(_postData) {
    return http.post(URL.API_STUDENT_MEAL_GET_STUDENT_LIST_BY_STATUS, _postData)
  },
  // 根据日期查询学生就餐记录
  getMealStudentMealRecord(_postData) {
    return http.get(URL.API_STUDENT_MEAL_GET_STUDENT_RECORD, _postData)
  },
  // 查询学生用餐设置
  getMealStudentMealSetting(_postData) {
    return http.get(URL.API_STUDENT_MEAL_GET_STUDENT_SETTING, _postData)
  },
  // 保存学生用餐设置
  saveMealStudentMealSetting(_postData) {
    return http.post(URL.API_STUDENT_MEAL_SAVE_STUDENT_SETTING, _postData)
  }
}
